import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, Subscription } from 'rxjs'; // this created errors ats use below

import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';

import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import {Location} from '@angular/common';
import { environment } from './../../../../environments/environment';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-company-create',
  templateUrl: './company-create.component.html',
  styleUrls: ['./company-create.component.css']
})
export class CompanyCreateComponent implements OnInit {


  today = new Date();
  today_ISO = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison

  
  stripped: any;
  filenameselected: any;
  get_latest_brand_id: any;
  public nav: any;
  public model: Brand;


  public baseUploadURL = environment.php_apiURL + '/uploads/test_area'; // no trailing slash
  @ViewChild('brandForm') form: any;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  brand_types: Object;

  user_ui_layout_id_Options = [
  { value: '1', label: 'DEFAULT: Client Job Submission' },
  { value: '2', label: 'Advanced: Client Job Submission - subject(s) appened to special instuctions' }
];

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      public toastr: HotToastService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public datepipe: DatePipe,
      public gfunc: GlobalFunctionsService
  ) { 
    this.nav = document.querySelector('nav.navbar');

  }

  ngOnInit() {
    this.model = new Brand();
    // Set some defaults
    this.model.is_active = 'Y';
    this.model.created = this.today_ISO;
    this.model.updated = this.today_ISO;
    this.model.updated_by = this.gfunc.sessionUserId;
    this.model.created_by = this.gfunc.sessionUserId;

    this.getBrandTypesNoOwner();
  }





  createBrandPrimary(model) {

    this._demoService.createBrandPrimary(model).subscribe(
  
         data => {  this.get_latest_brand_id = data; // this is the retuned json upon creation.
  
// Need to also add the new user in the PHP Insert.

           this.traceAddNotice ();
          this.router.navigate(['../../companies'], { relativeTo: this.route });
  
           //  return true;
         },
         error => {
           this.toastr.error('Adding Company Failed :: Please try again!');
           // console.log(Observable.throw(error));
           // return Observable.throw(error);
         }
    );
    }
  
    traceAddNotice () {
      this.toastr.info('Company Added');
    };
  
  
  
     // to router navigate back
     public goBack() {
      this._location.back();
    }
  
    brandView(brand_id) {
      this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
    }
    
    brandEdit(brand_id) {
      this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
    }
  
  
  
  
  
  // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
  
  // MODAL view a component
  openModalWithComponent() {
    const initialState = {
      list: [
        'Open a modal with component',
        'Pass your data',
        'Do something else',
        '...'
      ],
      title: 'Modal with component',
      item_id: 1010,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(FileUploadsModalComponent, {initialState});
  
    // subscribed to the emitter and get the value.
  //   this.bsModalRef.content.action.take(1).subscribe((value) => {
  // // console.log(value); // here you will get the value of the file
  // // Remove the "uploads/" part from the filename.
  // this.filenameselected = value;
  // this.stripped = this.filenameselected.replace('uploads/', '');
  // // this.model.main_image = this.stripped; // works for simple add not update.
  // // console.log(this.stripped);
  // // console.log(this.model);
  // this.form.logo = this.stripped;
  // // this.form.reset();
  // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
  // this.form.controls['logo'].patchValue(this.form.logo);
  
  // });
  
    this.bsModalRef.content.closeBtnName = 'Close';

    this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....

  }
  
  
// :: Parent / Child modal test
public addFileNameFromModal(filename) {

  alert('Clicked');
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

          // this.allRecipients.push({
          //   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
          //   recipient_email_address: model.recipient_email_address,
          //   recipient_brand_id: null,
          //   recipient_brand_type_id: null,
          //   recipient_user_id: null,
          //   recipient_user_level_id: null,
          //   recipient_type_name: model.recipient_type_name,
          // });

          // this.allRecipients = this.allRecipients;
          // this.model.allRecipients = this.allRecipients;



                  // this.filenameselected = model.new_filename;
                  // this.stripped = this.filenameselected.replace('uploads/', '');
                  // // this.model.main_image = this.stripped; // works for simple add not update.
                  // // console.log(this.stripped);
                  // // console.log(this.model);
                  // this.form.logo = this.stripped;
                  // // this.form.reset();
                  // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                  // this.form.controls['logo'].patchValue(this.form.logo);
// console.log('Returned Filename: ' , filename);

          // this.model.logo = filename;
          this.form.controls['logo'].patchValue(filename); // works by setting the new frorm value from parent modal.


// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};
  
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

     
  getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  
  






}
